module.exports = __webpack_public_path__ + "86ceb3f2cd0c07b61c683240fabf63ef.png";